import React, { useState } from "react";
import { Field } from "formik";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import WeightModal from "./WeightModal";

export default function WeightField({
  name = "weight",
  label,
  disabled,
  asset,
  handleUpdateAssetField,
  inputProps = {},
}) {
  const [open, setOpen] = useState(false);
  const isDisabled = Boolean(disabled);

  const handleToggle = () => {
    if (isDisabled) return;

    setOpen(v => !v);
  };

  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        const value = field.value == null || field.value === "" ? "" : String(field.value);
        const errorMessage = meta.error || form.errors[field.name];
        const error = (meta.touched || form.submitCount > 0) && errorMessage;

        const handleSave = weight => {
          form.setFieldValue(field.name, weight);
          if (handleUpdateAssetField && asset) {
            handleUpdateAssetField(field.name)(weight);
          }
          setOpen(false);
        };

        return (
          <>
            <FormControl fullWidth>
              <TextField
                size="small"
                disabled={isDisabled}
                autoComplete="off"
                label={label}
                value={value}
                variant="outlined"
                margin="none"
                error={!!error}
                helperText={error}
                inputProps={{
                  ...inputProps,
                  onClick: handleToggle,
                }}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    handleToggle();
                  }
                }}
              />
            </FormControl>
            {open && (
              <WeightModal
                title={label}
                initialValue={field.value}
                onClose={handleToggle}
                onSubmit={handleSave}
              />
            )}
          </>
        );
      }}
    </Field>
  );
}
